import React from "react";
import { InputJson, Button } from "nq-component";
import BaseFormPage from "../../../../base/BaseFormPage";
import {
  getObjectUseCase,
  upsertUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import { FloatingForm } from "../../../../components/common/Converter";
import CardView from "../../../../components/common/CardView";
import FormPayrollPresenter from "./FormPayrollPresenter";
import TablePayroll from "../table-payroll/TablePayroll";
import { getHeader } from "../table-payroll/header/TableHeader";
import { getHeaderSP } from "../table-payroll/header/TableHeaderSP";
import { getHeaderIP } from "../table-payroll/header/TableHeaderIP";
import LogoHeader from "../../../../components/common/LogoHeader";
import { calculations } from "../calculation-payroll/CalculationPayroll";
import FormFooter from "./form-footer/FormFooter";
import PrintPayrollList from "../print-payroll/PrintPayrollList";
import { getMinsDeducted } from "../employee-attendance/EmployeeAttendance";
import { caseKeyMap } from "../payroll-cases/CaseKeyMap";
import { getmodifiedTable } from "./table-object-helper/ModifyTable";
import { getAttendanceSummary } from "../employee-attendance/EmployeeAttendance";
import {
  updateTableObjects,
  updateTableObjects_1,
  updateTableObjects_2,
  updateTableObjects_3,
} from "./table-object-helper/TransformTableObjects";
import {
  convertLabels,
  mergeHeaders,
  getWholeDaysofMonth,
  countDateRanges,
  getDatesFromRange,
  sumProperties,
  getMonthNames,
  countAirportDuties,
  toCamelCase,
} from "../helper-payroll/HelperFunction";
import PayrollHeaderDisplay from "../../../../components/PayrollHeader/PayrollHeaderDisplay";
import PayrollFooterDisplay from "../../../../components/PayrollFooter/PayrollFooterDisplay";

export default class FormPayrollPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      isLoading: true,
      tableHeaders: {},
      tableObjects: [],
      tfootObjects: {},
      requestLists: {},
      deductionLists: {},
      otherCalculations: {},
      dateMetrics: {},
      value: 2000,
      dateRange: [],
      employees: [],
      isDataAddinRow: 1,
      isRemoved: false,
      signatories: {
        sectionName_1: "RHUBIE M. TAMAYO",
        sectionPos_1: "Acting Chief, Compensation & Employee Benefits Section",
        sectionName_2: "CHESTER KEVIN S. SY",
        sectionPos_2: "Chief, Accounting Section",
        sectionName_3: "MARY ANN Q. CARANTO",
        sectionPos_3: "Chief Administrative Division",
        sectionName_4: "LILIBETH F. LINTAG",
        sectionPos_4: "Disbursing Officer",
      },
    };
    this.contractPDF = React.createRef();
    // this.printRef = React.createRef();
    this.presenter = new FormPayrollPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
      findObjectUseCase()
    );
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const { objects, otherInfo, panelState } = this.props;

    console.log("objects", objects)

    console.log("OTHER INFO", otherInfo)
    console.log("PANEL STATE", panelState)

    const [otherDeduction, contributions, incentives] = await Promise.all([
      findObjectUseCase().execute("other_deductions", {
        include: ["accTitleRelation.accountsTitle", "employmentTypes"],
        where: {
          payrollTypes: panelState?.payrollTypeVal,
          "employmentTypes.id": panelState?.jobTypeID,
          payItems: panelState?.payItemVal,
        },
      }),
      findObjectUseCase().execute("contribution_type"),
      findObjectUseCase().execute("incentive", {
        include: ["allowanceType"],
        // where: {
        //   id: otherInfo.incentiveId,
        // },
      }),
    ]);

    console.log("incentives12", incentives);

    const contributionType = contributions.map((item) => item.contributionType);

    const { DEDUCTION, ADDITIONAL } = otherDeduction.reduce(
      (acc, item) => {
        const isDeduction = item?.deductionTypes === "Other Deduction";
        const isAdditional = item?.deductionTypes === "Other Additional";

        if (!item?.accTitleRelation || (!isDeduction && !isAdditional))
          return acc;

        for (const rel of item?.accTitleRelation) {
          const name = rel?.accountsTitle?.name;
          if (!name) continue;

          if (isDeduction) acc.DEDUCTION.push(name);
          else if (isAdditional) acc.ADDITIONAL.push(name);
        }

        return acc;
      },
      { DEDUCTION: [], ADDITIONAL: [] }
    );

    const deductionLists = {
      deductionType: DEDUCTION,
      additionalType: ADDITIONAL,
      contributionType,
      contributions,
      incentives,
      otherInfo,
    };

    const [tableHeader, primarySubHdr, secondarySubHdr] =
      panelState?.payrollTypes === "SP"
        ? getHeaderSP(panelState, deductionLists)
        : panelState?.payrollTypes === "IP"
        ? getHeaderIP(panelState, deductionLists)
        : getHeader(panelState, deductionLists);

    const requestLists = await this.presenter.getRequests(deductionLists);
    console.log("requestListss", requestLists);

    const otherCalculations = calculations(
      objects,
      panelState,
      requestLists,
      otherInfo,
      panelState?.datePicked,
      "",
      {}
    );

    const tableObjects = this.presenter._getTableData(
      objects,
      otherCalculations,
      requestLists
    );

    console.log("tableObjects", tableObjects);

    const caseName = this.presenter.getMatchingCase();
    const keysToSum = caseKeyMap[caseName] || [];

    const tfootObjects = sumProperties(tableObjects, keysToSum, deductionLists);

    const combinedHeaders = mergeHeaders(
      tableHeader,
      primarySubHdr,
      secondarySubHdr
    );

    const convertedHeaders = convertLabels(combinedHeaders);
    console.log("convertedHeaders", convertedHeaders);

    const tableHeaders = {
      tableHeader,
      primarySubHdr,
      secondarySubHdr,
      convertedHeaders,
    };

    this.setState({
      tableHeaders,
      requestLists,
      deductionLists,
      tableObjects,
      tfootObjects,
      otherCalculations,
      isLoading: false,
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      this.handleInputFieldChange();
    }
    if (prevState.dateRange !== this.state.dateRange) {
      await this.handleDateRangeChange();
    }
  }

  async handleInputFieldChange() {
    const { panelState, objects, otherInfo } = this.props;
    const { tableObjects, deductionLists, requestLists, value } = this.state;

    const otherCalculations = calculations(
      objects,
      panelState,
      requestLists,
      otherInfo,
      panelState?.datePicked,
      value,
      tableObjects
    );

    const caseListName = this.presenter.getCaseListName();
    const { caseLists, cases } = caseListName;
    const params = {
      otherCalculations,
      tableObjects,
      caseLists,
      cases,
      panelState,
    };
    const newTableObject = updateTableObjects(params);

    const caseName = this.presenter.getMatchingCase();
    const keysToSum = caseKeyMap[caseName] || [];

    const tfootObjects = sumProperties(
      newTableObject,
      keysToSum,
      deductionLists
    );

    this.setState({ tableObjects: newTableObject, tfootObjects });
  }

  async handleDateRangeChange() {
    const {
      tableObjects,
      employees,
      dateMetrics,
      isRemoved,
      isDataAddinRow,
      deductionLists,
      requestLists,
    } = this.state;

    console.log("");

    const { panelState, objects, otherInfo } = this.props;
    const { daysInMonth, periodCount, selectedDate, monthNames } = dateMetrics;
    const airportSched = otherInfo?.numberOfDutiesinAP?.filteredEmployeeDuty;

    const caseListName = this.presenter.getCaseListName();
    const { caseLists, cases } = caseListName;
    const mandatoryFormula = requestLists?.mandatoryFormula || {};

    const lateUndertime =
      (await getAttendanceSummary(
        employees,
        selectedDate,
        airportSched,
        cases
      )) ?? [];

    console.log("lateUndertimeweew", lateUndertime);

    const noOfDuties = countAirportDuties(airportSched, selectedDate, objects);

    const lateUtLogs = {};
    lateUndertime?.regular.forEach(
      ({
        employeeId,
        totalDeductedMins,
        totalAbsences,
        totalHalfDays,
        workingDates,
        allMinsIncurred,
        dateOfAbsences,
      }) => {
        lateUtLogs[employeeId] = {
          totalDeductedMins,
          totalAbsences,
          totalHalfDays,
          workingDates,
          allMinsIncurred,
          dateOfAbsences,
        };
      }
    );

    const lateUtLogsAirport = {};
    lateUndertime?.airport.forEach(
      ({ employeeId, totalDeductedMins, totalAbsences }) => {
        lateUtLogsAirport[employeeId] = {
          totalDeductedMins,
          totalAbsences,
        };
      }
    );

    const params_1 = {
      tableObjects,
      lateUtLogs,
      lateUtLogsAirport,
      noOfDuties,
      daysInMonth,
      periodCount,
      monthNames,
      cases,
      employees,
    };
    const updatedTableObj = updateTableObjects_1(params_1);

    // console.log("updatedTableObj", updatedTableObj);

    this.setState({ tableObjects: updatedTableObj }, async () => {
      const otherCalculations = calculations(
        objects,
        panelState,
        requestLists,
        otherInfo,
        panelState?.datePicked,
        this.state.value,
        updatedTableObj
      );

      const params_2 = {
        otherCalculations,
        updatedTableObj,
        caseLists,
        cases,
      };
      const newTableObject = updateTableObjects_2(params_2);

      console.log("newTableObject", newTableObject);

      const caseName = this.presenter.getMatchingCase();
      const keysToSum = caseKeyMap[caseName] || [];


      if (isDataAddinRow >= 1) {
        const args = {
          newTableObject,
          isMultipleRows: isDataAddinRow > 1,
          isRemoved,
          mandatoryFormula,
          caseName,
        };

        const modifiedTable = getmodifiedTable(args);

        // console.log("modifiedTable", modifiedTable);

        const otherCalculations = calculations(
          objects,
          panelState,
          requestLists,
          otherInfo,
          panelState?.datePicked,
          this.state.value,
          modifiedTable
        );

        const params_3 = {
          otherCalculations,
          modifiedTable,
          caseLists,
          cases,
        };

        const modifiedTableObject = updateTableObjects_3(params_3);

        // console.log("modifiedTableObject", modifiedTableObject);

        const tfootObjects = sumProperties(
          modifiedTableObject,
          keysToSum,
          deductionLists
        );

        this.setState({ tableObjects: modifiedTableObject, tfootObjects });
      } else {
        const tfootObjects = sumProperties(
          newTableObject,
          keysToSum,
          deductionLists
        );
        this.setState({ tableObjects: newTableObject, tfootObjects });
      }
    });
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  getCollectionName() {
    return "payroll";
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleSignatoryChange = (section, value) => {
    this.setState((prevState) => ({
      signatories: {
        ...prevState.signatories,
        [section]: value,
      },
    }));
  };

  handleAction(type, index, label) {
    if (type === "Add") {
      this.setState((prevState) => ({
        isDataAddinRow: (prevState.isDataAddinRow || 0) + 1,
        isRemoved: false,
      }));
    } else {
      this.setState({ isRemoved: true });
    }
  }

  handleInputChange(value, index, label, id) {
    const updatedValue = { ...this.state.value };
    const { panelState } = this.props;

    if (!updatedValue[index]) updatedValue[index] = {};

    if (label !== "date") {
      updatedValue[index][label] = value === "" ? 0 : value;

      this.setState({ value: updatedValue });
      return;
    }

    // Handle date input
    if (Array.isArray(value)) {
      const flattenedValue = value.flat() ?? [];
      const combinedDates = flattenedValue
        .map((datePair) => {
          if (Array.isArray(datePair) && datePair.length === 2) {
            return `${datePair[0]} - ${datePair[1]}`;
          }
          return null;
        })
        .filter(Boolean);

      const dateRange = [...this.state.dateRange];
      if (!dateRange[id]) {
        dateRange[id] = [];
      }

      dateRange[id].push(...combinedDates);
      const employees = this.props.objects.filter((item) => item.id === id);

      const selectedDate = getDatesFromRange(dateRange);
      const daysInMonth = getWholeDaysofMonth(dateRange);
      const periodCount = countDateRanges(dateRange);
      const monthNames = getMonthNames(dateRange);

      const dateMetrics = {
        selectedDate,
        daysInMonth,
        periodCount,
        monthNames,
      };

      this.setState({ value: updatedValue, dateRange, employees, dateMetrics });
    }
  }

  render() {
    const { tableHeaders, tableObjects, tfootObjects, signatories, dateRange } =
      this.state;
    console.log("tableObjectss", tableObjects);
    const { closeFloating, panelState, otherInfo } = this.props;
    const { payrollHeader } =
      otherInfo;
    const { payrollPeriod } = panelState;
    const schema = this.getSchema(this.getCollectionName());

    if (!schema) return <h1>no schema</h1>;

    const buttons = [
      {
        label: "Save",
        icon: "bi-save",
        type: "submit",
        className: "btn btn-primary",
      },
      {
        label: "Cancel",
        icon: "bi-x-circle",
        type: "button",
        className: "btn btn-light",
        onClick: closeFloating,
      },
      {
        label: "Print",
        icon: "bi-printer",
        type: "button",
        className: "btn border-primary text-primary",
        onClick: () => this.presenter._onPrintPayroll(),
      },
    ];
    return (
      <>
        <FloatingForm width="95%">
          <CardView style={{ padding: 0 }}>
            <h4 className="p-2 m-0 text-primary">Generate Payroll</h4>
            <hr className="m-0 mb-2"></hr>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.presenter._onSavePayroll();
              }}
            >
              {/* <div className="d-flex justify-content-center flex-column align-items-center flex-md-row  p-2">
                <LogoHeader
                  logoSrc={"/BIR.png"}
                  rightLogoSrc={"/Bagong-Pilipinas-Logo.png"}
                  mainLabel="Republic Of the Philippines"
                  subLabel="BUREAU OF IMMIGRATION"
                  description="Patriotism * Integrity * Professionalism"
                />
              </div> */}
              {payrollHeader?.value?.header && (
                <div className="mb-1">
                  <PayrollHeaderDisplay header={payrollHeader?.value?.header} />
                </div>
              )}
              <h5 className="text-center">{panelState?.payrollTypeVal}</h5>
              <p className="text-center">{payrollPeriod?.payrollCode ?? ""}</p>
              {!(
                panelState?.payItems === "Addendum Back-Pay" ||
                panelState?.payItems === "Back-Pay"
              ) && (
                <p className="text-center">
                  {payrollPeriod?.periodCovered?.startDate && payrollPeriod?.periodCovered?.endDate
                    ? `${payrollPeriod?.periodCovered.startDate} - ${payrollPeriod?.periodCovered.endDate}`
                    : payrollPeriod?.year
                    ? payrollPeriod?.year
                    : `${payrollPeriod?.monthFrom}${payrollPeriod?.monthTo ? " - " + payrollPeriod?.monthTo : ""}`}
                </p>
              )}

              <div className="row pt-2 ps-2 pe-2 pb-0 m-0">
                <div className="pt-1 ps-1 pe-1 pb-0 ">
                  <TablePayroll
                    tableHeader={tableHeaders?.tableHeader ?? []}
                    primarySubHdr={tableHeaders?.primarySubHdr ?? []}
                    secondarySubHdr={tableHeaders?.secondarySubHdr ?? []}
                    headersKey={tableHeaders?.convertedHeaders}
                    object={this.state.tableObjects}
                    tfootObjects={tfootObjects}
                    selectedTypes={panelState}
                    isLoading={this.state.isLoading}
                    onChange={this.handleInputChange.bind(this)}
                    onclickAction={this.handleAction.bind(this)}
                    value={this.state.value}
                    schema={schema}
                  />
                </div>
              </div>
              <br></br>

              {/* <div style={{ display: "none" }}>
                <div ref={this.contractPDF} id="contractPDF">
                  <PrintPayrollList
                    object={tableObjects}
                    headers={tableHeaders}
                    tfootObjects={tfootObjects}
                    otherData={{
                      selectedTypes,
                      value: this.state.value,
                      signatories,
                    }}
                  />
                </div>
              </div> */}

              {/* <FormFooter
                signatories={signatories}
                onNameChange={this.handleSignatoryChange}
                onPositionChange={this.handleSignatoryChange}
              /> */}
              
              <PayrollFooterDisplay footer={payrollHeader?.value?.footer} />

              <hr></hr>
              {/* Sticky buttons at bottom */}
              <div 
                className="w-100 d-flex justify-content-end gap-2"
                style={{
                  position: 'sticky',
                  bottom: 0,
                  backgroundColor: 'white',
                  padding: '1rem 1.5rem',
                  zIndex: 1000,
                  marginTop: '1rem',
                }}
              >
                {buttons.map(({ label, icon, type, className, onClick }) => (
                  <Button
                    type={type}
                    key={label}
                    className={className}
                    onClick={onClick}
                  >
                    <i className={`bi ${icon}`}></i>&nbsp;{label}
                  </Button>
                ))}
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
